import React, { Children, InputHTMLAttributes } from "react";
import styled from "styled-components";

export interface ICheckboxProps {
  classNames?: string;
  inputClassName?: string;
  label: string;
  /*
   * Used for input 'ID', 'name', and label's 'for' attributes
   */
  idName: string;
  /*
   * ID of related form for use with external inputs
   */
  parentForm?: string;
  /**
   * Properties to pass to the input element.
   */
  inputProps?: Partial<InputHTMLAttributes<HTMLInputElement>>;
}

const StyledInput = styled.input`
  /* Remove most all native input styles */
  appearance: none;
  margin: 0 0.5rem 0 0;

  font: inherit;
  width: 1.15rem;
  height: 1.15rem;
  border-width: 0.15rem;
  border-style: solid;
  transform: translateY(-0.075rem);
  display: inline-grid;
  place-content: center;

  &::before {
    content: "";
    width: 0.65rem;
    height: 0.65rem;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1rem 1rem var(--color-button-bg);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
  }

  &:checked::before {
    transform: scale(1);
  }

  &:focus {
    outline: max(2px, 0.15rem) solid currentColor;
    outline-offset: max(2px, 0.15rem);
  }

  &::disabled {
    cursor: not-allowed;
  }
`;

const Checkbox: React.FC<ICheckboxProps> = ({
  classNames,
  inputClassName,
  label,
  idName,
  parentForm,
  inputProps,
}) => {
  return (
    <label htmlFor={idName} className={`nowrap ${classNames}`}>
      <StyledInput
        type="checkbox"
        name={idName}
        id={idName}
        className={`mr-2 ${inputClassName}`}
        {...inputProps}
      />
      {label}
    </label>
  );
};

export default Checkbox;
